<app-base-edit-form
  [fields]="fields"
  [baseService]="addressService"
  [closeOnSave]="closeOnSave()"
  [id]="id()"
  (saved)="saved.emit($event)"
>
</app-base-edit-form>
